import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GreenroomState as GS } from '../../../../stores/types/types';
import {
	HeaderContainer,
	StyledButton,
	StyledLabel,
	StyledLi,
	StyledSpan,
	StyledUl,
} from '../debug-ui';
import { DeleteOnsiteLocation, DeleteSrtStream } from '../../../../connection/video';
import useShots from '../../../../contexts/shots/provider';
import { FEED_TYPES } from '../../../../stores/reducers/shots';
import { setSelectedOnsiteLocationId } from '../../../../stores/actions/video';
import { setMetaMenuRoute, setMetaMenuState } from '../../../../stores/actions/tabs';
import { META_MENU_ROUTES, META_MENU_STATES } from '../../../../stores/types/tabs';
import type { OnsiteLocation } from '../../../../stores/types/video';

export default function DebugOnsiteLocations() {
	const dispatch = useDispatch();

	const token = useSelector((s: GS) => s.SessionReducer.token);
	const meeting = useSelector((s: GS) => s.SessionReducer.meeting);
	const onsiteLocations = useSelector((s: GS) => s.VideoReducer.onsiteLocations);

	const { stripFeedFromShots } = useShots();

	const handleEditLocation = (locationId: number) => {
		dispatch(setSelectedOnsiteLocationId(locationId));
		dispatch(setMetaMenuRoute(META_MENU_ROUTES.ONSITE_LOCATION));
		dispatch(setMetaMenuState(META_MENU_STATES.OPENING));
	};

	const handleDeleteLocation = async (location: OnsiteLocation) => {
		if (!token || !meeting) return false;
		stripFeedFromShots(location.id, FEED_TYPES.ONSITE_LOCATION);
		// if an srt stream has been created for this location, delete it
		if (location.srtId) await DeleteSrtStream(token, meeting.meeting, location.srtId);
		return !!await DeleteOnsiteLocation(token, meeting.meeting, location.id);
	};

	return (
		<div className="section settings">
			<HeaderContainer>
				<h5>Onsite Locations</h5>
			</HeaderContainer>
			<div className="advanced-settings-container">
				<StyledUl>
					{onsiteLocations.map((location) => (
						<StyledLi
							className="justify-content-space-between width-full"
							key={location.id}
							style={{ height: '40px' }}
						>
							<div className="truncate-overflow">
								<StyledLabel>ID:</StyledLabel>
								<StyledSpan>{location.id}</StyledSpan>
								<StyledLabel className="margin-left-medium">NAME:</StyledLabel>
								<StyledSpan>{location.locationName}</StyledSpan>
							</div>
							<div className="flex gap-small">
								<StyledButton
									className="background-green text-dark"
									onClick={() => handleEditLocation(location.id)}
								>
									Edit
								</StyledButton>
								<StyledButton
									className="background-red text-white"
									onClick={() => handleDeleteLocation(location)}
								>
									Delete
								</StyledButton>
							</div>
						</StyledLi>
					))}
				</StyledUl>
			</div>
		</div>
	);
}
